<template>
  <div>
    <v-navigation-drawer app temporary v-model="drawer">
      <v-row v-if="user" justify="center" class="pt-4">
        <v-avatar color="grey" size="100">
          <v-img v-if="user.photo" :src="user.photo" :alt="user.firstName" />
          <span v-else class="white--text subtitle-2">
            {{ user.firstName | initial }}
            {{ user.lastName | initial }}
          </span>
        </v-avatar>
      </v-row>
      <v-row v-if="user" justify="center" class="py-1">
        <div class="subtitle-2">
          {{ user.firstName }} {{ user.middleName }} {{ user.lastName }}
        </div>
      </v-row>
      <v-divider></v-divider>

      <v-list>
        <v-list-item
          v-for="(item, index) in menuItems"
          :key="index"
          link
          :to="item.link"
          active-class="tile"
        >
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item v-if="user" link active-class="tile" @click="logout">
          <v-list-item-content>
            <v-list-item-title>Log ud</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app>
      <v-img
        class="mr-0 mt-n3"
        contain
        max-height="25"
        max-width="25"
        src="@/assets/khlogo.svg"
        alt
      />
      <v-toolbar-title>
        <router-link to="/" class="toolbar-title">
          <div>Kompetencehuset</div>
        </router-link>
      </v-toolbar-title>
      <v-spacer />
      <v-toolbar-items v-if="$vuetify.breakpoint.mdAndUp">
        <!-- IF USER else log in link -->
        <v-btn
          v-for="item in menuItems"
          :key="item.title"
          :to="item.link"
          text
          >{{ item.title }}</v-btn
        >
      </v-toolbar-items>
      <!-- IF USER -->

      <NavbarMenu v-if="user && $vuetify.breakpoint.mdAndUp" :user="user" />

      <v-app-bar-nav-icon
        v-if="$vuetify.breakpoint.smAndDown"
        @click="drawer = !drawer"
      />
    </v-app-bar>
  </div>
</template>

<script>
import NavbarMenu from "@/components/NavbarMenu.vue";
import * as firebase from "firebase/app";
import "firebase/auth";
export default {
  methods: {
    logout() {
      console.log("logging out");
      firebase
        .auth()
        .signOut()
        .then(data => {
          this.$store.dispatch("logout");
          this.$router.replace({ path: "/" });
          console.log("sign out", data);
        });
    }
  },
  data() {
    return {
      drawer: null
    };
  },
  components: {
    NavbarMenu
  },
  computed: {
    menuItems() {
      let menuItems = [{ title: "Log ind", link: "/login" }];
      if (this.user) {
        menuItems = [
          //  { title: "SMS", link: "/sms" },
          { title: "Hold", link: "/hold" },
          { title: "Ansatte", link: "/ansatte" }
        ];

        if (this.user.id === "Y3YXNDQ69uqQZQHW47Jv") {
          menuItems.unshift({
            title: "Test",
            link: "/test"
          });
        }
        if (this.user.admin === true) {
          menuItems.push({
            title: "Admin",
            link: "/admin"
          });
        }
      }

      return menuItems;
    },
    user() {
      return this.$store.getters.user;
    }
  }
};
</script>

<style lang="scss" scoped>
.toolbar-title {
  color: inherit;
  text-decoration: inherit;
}
</style>
